"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTabbable = void 0;
var tabbableElements = ["button", "input", "object", "select", "textarea", "a"];
function isTabbable(element) {
    var elementType = element.tagName.toLowerCase();
    if (tabbableElements.indexOf(elementType) > -1) {
        if (elementType !== "a" || (elementType === "a" && element.hasAttribute("href"))) {
            return true;
        }
    }
    var activeElem = getActiveElement();
    var activeElemType = activeElem.tagName.toLowerCase();
    if (tabbableElements.indexOf(activeElemType) > -1) {
        if (activeElemType !== "a" || (activeElemType === "a" && activeElem.hasAttribute("href"))) {
            return true;
        }
    }
    if (element.hasAttribute("tabindex")) {
        var tabIndex = Number(element.getAttribute("tabindex"));
        return !isNaN(tabIndex) && tabIndex >= 0;
    }
    if (activeElem.hasAttribute("tabindex")) {
        var actTabIndex = Number(activeElem.getAttribute("tabindex"));
        return !isNaN(actTabIndex) && actTabIndex >= 0;
    }
    return false;
}
exports.isTabbable = isTabbable;
function getActiveElement(root) {
    if (root === void 0) {
        root = document;
    }
    var activeEl = root.activeElement;
    if (!root.activeElement)
        return null;
    if (activeEl.shadowRoot)
        return getActiveElement(activeEl.shadowRoot);
    return activeEl;
}
//# sourceMappingURL=module.js.map